import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertOctagon, HelpCircle } from '@/components/icons';

interface WorkspaceSuspendedBannerProps {
  workspaceName?: string;
  /** PM (workspace) company label surfaced to residents, e.g. "Acme PM". */
  pmLabel?: string;
}

export const WorkspaceSuspendedBanner: React.FC<WorkspaceSuspendedBannerProps> = ({
  workspaceName,
  pmLabel,
}) => {
  const { t } = useTranslation();
  const label = pmLabel || t('suspension.default_pm');

  return (
    <div className="bg-amber-950/90 border-b border-amber-600/50 text-amber-100 px-4 py-2.5 shadow-md flex flex-col sm:flex-row items-center justify-between gap-3 text-xs">
      <div className="flex items-center gap-2.5 min-w-0">
        <div className="p-1 rounded-md bg-amber-500/20 text-amber-400 shrink-0">
          <AlertOctagon className="w-4 h-4" />
        </div>
        <div>
          <span className="font-bold uppercase tracking-wider text-[10px] px-1.5 py-0.5 rounded bg-amber-500/30 text-amber-200 mr-2">
            {t('suspension.read_only_badge')}
          </span>
          <span className="font-semibold">
            {t('suspension.suspended_line', { workspace: workspaceName || 'Workspace' })}
          </span>{' '}
          <span className="opacity-90">{t('suspension.view_only_line')}</span>
          <span className="block sm:inline text-amber-200/90 mt-0.5 sm:mt-0 sm:ml-1">
            {t('suspension.contact_pm_line', { pm: label })}
          </span>
        </div>
      </div>

      <a
        href="mailto:support@koinon.pro?subject=Workspace%20Suspension%20Inquiry"
        className="inline-flex items-center gap-1.5 px-3 py-1 text-xs font-semibold rounded-lg bg-amber-500 hover:bg-amber-400 text-amber-950 transition-colors shrink-0 shadow-sm"
      >
        <HelpCircle className="w-3.5 h-3.5" />
        {t('suspension.contact_support')}
      </a>
    </div>
  );
};
